// src/pages/Home/Diaporama.jsx
import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getAllGalleries } from "../../services/gallerieServices";
import { getSettings } from "../../services/settingsServices";
import "./Diaporama.css";

const Diaporama = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGalleryPhotos = async () => {
      try {
        const settings = await getSettings();
        const carrouselId = settings[0]?.carrousel_id;

        if (carrouselId) {
          const galleries = await getAllGalleries();
          const selectedGallery = galleries.find(
            (gallery) => gallery.id === carrouselId
          );
          if (selectedGallery && selectedGallery.photos) {
            setPhotos(
              selectedGallery.photos.filter((photo) => photo.is_active)
            );
          }
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des photos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGalleryPhotos();
  }, []);

  if (loading) {
    return (
      <section className="py-10 md:py-14 bg-slate-50 dark:bg-slate-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="diaporama-skeleton">
            <div className="diaporama-skeleton-inner">
              Chargement des moments forts en images...
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!photos.length) {
    return null; // ou un petit message discret si tu préfères
  }

  return (
    <section className="py-10 md:py-14 bg-slate-50 dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Titre / sous-titre */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 mb-5">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-primary mb-1">
              Galeries
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900 dark:text-slate-50">
              Moments forts en images
            </h2>
          </div>
          <p className="text-xs md:text-sm text-slate-500 dark:text-slate-400 max-w-md">
            Une sélection de photos issues des événements du comité et des clubs
            girondins.
          </p>
        </div>

        {/* Carte du carrousel */}
        <div className="diaporama-card">
          <Carousel
            className="diaporama-carousel"
            autoPlay
            infiniteLoop
            useKeyboardArrows
            showThumbs={false}
            showStatus={false}
            interval={5000}
            swipeable
            emulateTouch
            dynamicHeight={false}
            renderArrowPrev={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  className="diaporama-arrow diaporama-arrow-left"
                >
                  ‹
                </button>
              )
            }
            renderArrowNext={(onClickHandler, hasNext, label) =>
              hasNext && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  className="diaporama-arrow diaporama-arrow-right"
                >
                  ›
                </button>
              )
            }
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              const baseClass = "diaporama-dot";
              const activeClass = isSelected ? " active" : "";
              return (
                <button
                  type="button"
                  key={index}
                  className={baseClass + activeClass}
                  onClick={onClickHandler}
                  title={label}
                />
              );
            }}
          >
            {photos.map((photo) => (
              <div key={photo.id} className="diaporama-slide">
                <img
                  src={photo.photo_url}
                  alt={photo.description || "Photo diaporama"}
                />
                {photo.description && (
                  <div className="diaporama-caption">
                    {photo.description}
                  </div>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Diaporama;
